export default "__VITE_ASSET__e4fdf85a__"